import styled from 'styled-components';

export const Container = styled.main<{ bgColor?: string }>`
  width: 100%;
  margin-left: 120px;
  margin-top: 50px;
  display: flex;
  flex-direction: column;
`;
